export const brandName = "NexGen Web Designs";

export const phoneNumber = "+918331889448";

export const whatsappNumber = "+918330920858";

export const whatsappNumber1 = "+918331889448";

export const whatsappLink = `https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=Hello%21%20I%27m%20interested%20in%20your%20web%20development%20services.&type=phone_number&app_absent=0`;

export const whatsappLink1 = `https://api.whatsapp.com/send/?phone=${whatsappNumber1}&text=Hello%21%20I%27m%20interested%20in%20your%20web%20development%20services.&type=phone_number&app_absent=0`;

export const emailAddress = "info@nexgenwebdesigns.com";

export const emailAddress1 = "contact@nexgenwebdesigns.com";

export const address = "Katrenikona, Andhra Pradesh, India.";

export const address2 = "Kondapur, Hyderabad, India.";

export const fullAddress2 =
  "1-114/C, Vutla Sattaiah Colony, Hanuman Nagar, Raghavendra Colony, Hyderabad, Kondapur, Telangana_500084";

export const fullAddress1 =
  "1-47 , Santa Market , Katrenikona , katrenikona Mandal, Konaseema District, Andhra Pradesh_533212";
export const maintainence = false;

export const Prices = {
  basic: { actual: 5999, offer: 2999, extraOffer: 2999 },
  standard: { actual: 6999, offer: 3999, extraOffer: 3999 },
  premium: { actual: 11999, offer: 7999, extraOffer: 5999 },
  custom: { actual: 19999, offer: 16999, extraOffer: 12999 },
};

export const offerExpireDate = new Date("2026-02-01T23:59:59").getTime();

export const counts = {
  projectsCount: 5,
  clientsCount: 5,
  awardsCount: 0,
  hoursCount: 336,
};
